import { Eye, Video, ShieldCheck, Award } from "lucide-react";
import { TutorBrowser } from "@/components/TutorBrowser";

const IMG = "https://images.unsplash.com/photo-1616587894289-86480e533129?w=1200&q=80";
const values = [[Eye, "Transparency", "Every credit movement is recorded and visible in your wallet."],
  [Video, "Live collaboration", "Real-time video classes, one-to-one or in small groups."],
  [ShieldCheck, "Credit security", "Credits are reserved, never double-charged, and released on cancellation."],
  [Award, "Verified excellence", "Tutors and students are approved by our admin team."]];

export function About() {
  return (
    <div>
      <section className="relative overflow-hidden bg-[#0B1A33] text-white">
        <div className="grid-texture absolute inset-0" />
        <div className="relative mx-auto grid max-w-7xl gap-12 px-4 py-20 sm:px-6 lg:grid-cols-2 lg:px-12">
          <div className="rise">
            <p className="text-xs font-semibold uppercase tracking-wider text-[#3CC34A]">About FosterApp</p>
            <h1 className="mt-4 text-4xl font-extrabold sm:text-5xl">Expert live tutoring, made accountable.</h1>
            <p className="mt-6 text-slate-300">FosterApp is an online coaching platform where students find verified tutors, request coaching and attend live video classes. Tutors approve students, run group sessions and teach from one dashboard, while administrators keep approvals and credits fair and transparent.</p>
          </div>
          <img src={IMG} alt="Tutor teaching online" className="rise d2 h-80 w-full rounded-3xl object-cover" />
        </div>
      </section>
      <section className="mx-auto grid max-w-7xl gap-6 px-4 py-20 sm:px-6 md:grid-cols-2 lg:grid-cols-4 lg:px-12">
        {values.map(([Icon, t, d]) => (
          <div key={t} className="lift rounded-2xl border border-slate-200/80 bg-white p-7">
            <Icon className="h-7 w-7 text-[#1F6FFF]" />
            <h3 className="mt-4 text-lg font-bold text-[#0B1A33]">{t}</h3>
            <p className="mt-2 text-sm text-slate-500">{d}</p>
          </div>
        ))}
      </section>
    </div>
  );
}

export function FindTutorsPage() {
  return (
    <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-12">
      <p className="text-xs font-semibold uppercase tracking-wider text-[#1F6FFF]">Find tutors</p>
      <h1 className="mb-8 mt-2 text-3xl font-extrabold text-[#0B1A33] sm:text-4xl" data-testid="page-title">Find your perfect tutor</h1>
      <TutorBrowser profileBase="/tutors" />
    </div>
  );
}
